import { Button } from "@/components/button";
import IconRun from "~icons/tabler/run";
import { TIME_MARKER_ID } from "../timeline";
import { useTracksBuffer } from "@/services/buffer-controller";
import {
  usePlaybackMediator,
  useTimelinePlayback,
} from "@/contexts/playback-context";
import { toast } from "react-hot-toast";
import { Tooltip } from "@radix-ui/themes";

export function SkipToNextTrack() {
  const timelinePlayback = useTimelinePlayback();
  const mediator = usePlaybackMediator();
  const [tracksBuffer] = useTracksBuffer();

  const onClick = () => {
    const currentTime = timelinePlayback.currentTime.peek();
    const range = tracksBuffer.timeRanges.findNextTimeRange(currentTime);

    if (range) {
      mediator.seek(new Date(range[0]), TIME_MARKER_ID);
    } else {
      toast("There's no other track");
    }
  };

  return (
    <Tooltip content="Jump to nearest track">
      <Button onClick={onClick}>
        <IconRun />
      </Button>
    </Tooltip>
  );
}
